export default __webpack_public_path__ + "static/media/swiper2.8d776847.png";